import React from "react";
import { FaUserShield, FaExclamationTriangle, FaTimesCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ProfileVerificationRequiredNotification = ({ verificationStatus, verificationNotes }) => {
    const navigate = useNavigate();
    const isRejected = verificationStatus === 'rejected';

    return (
        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-8 space-y-6">
            <div className="flex flex-col items-center justify-center mb-4">
                {isRejected ? (
                    <FaTimesCircle className="h-12 w-12 text-red-500 mb-2" />
                ) : (
                    <FaUserShield className="h-12 w-12 text-amber-600 mb-2" />
                )}
                <h2 className="text-2xl font-bold text-gray-800">
                    {isRejected ? 'Profile Verification Rejected' : 'Profile Verification Required'}
                </h2>
            </div>

            <div className="space-y-4">
                {isRejected ? (
                    <>
                        <div className="flex items-start space-x-3">
                            <FaTimesCircle className="h-5 w-5 text-red-500 flex-shrink-0 mt-0.5" />
                            <div>
                                <h3 className="font-semibold text-gray-800">
                                    Your profile was not approved
                                </h3>
                                <p className="text-gray-600 mt-1">
                                    The admin has reviewed your profile and it was not approved. Please update your information and resubmit.
                                </p>
                            </div>
                        </div>
                        {verificationNotes && (
                            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                                <p className="text-sm font-medium text-red-800 mb-1">Reason:</p>
                                <p className="text-sm text-red-700">{verificationNotes}</p>
                            </div>
                        )}
                        <div className="flex justify-center">
                            <button
                                onClick={() => navigate("/profile/edit")}
                                className="px-6 py-3 bg-red-600 text-white rounded-lg font-medium hover:bg-red-700 transition-colors"
                            >
                                Update Profile & Resubmit
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="flex items-start space-x-3">
                            <FaExclamationTriangle className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
                            <div>
                                <h3 className="font-semibold text-gray-800">
                                    Your profile is awaiting admin verification
                                </h3>
                                <p className="text-gray-600">
                                    You cannot create listings until your profile has been
                                    reviewed and approved by an administrator.
                                </p>
                            </div>
                        </div>

                        <div className="text-center text-gray-500">
                            <p>
                                Please complete your owner profile and wait for admin
                                approval. You'll receive a notification once verified.
                            </p>
                        </div>

                        <div className="flex justify-center">
                            <button
                                onClick={() => navigate("/profile/edit")}
                                className="px-6 py-3 bg-amber-600 text-white rounded-lg font-medium hover:bg-amber-700 transition-colors"
                            >
                                Go to Profile Completion
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ProfileVerificationRequiredNotification;
